// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import CarBasesList from './CarBasesList';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(CarBasesList);
